<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-05-26 15:22:34
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-19 17:11:01
 * @FilePath: \partner.chaoyongtuan.com\src\components\shopScore\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-popover
		:placement="placement"
		:openDelay="openDelay"
		:visibleArrow="visibleArrow"
		width="380"
		trigger="click"
		popper-class="custom-popper-l"
		@show="handleShow"
		@after-leave="handleAfterLeave"
	>
		<div class="yx-color-pure-1" v-loading="loading">
			<p class="title font-bold fz-14">{{ shopName }}</p>
			<shop-view :shopScores="shopScores" />
		</div>
		<div slot="reference">
			<slot v-bind:shopScores="shopScores" name="popover"></slot>
		</div>
	</el-popover>
</template>
<script>
import shopView from './view.vue';
import { shopScores } from '@/api/shopManage';
export default {
	components: {
		shopView,
	},
	props: {
		visibleArrow: {
			type: Boolean,
			default: false,
		},
		placement: {
			type: String,
			default: 'bottom',
		},
		shopName: {
			type: String,
			default: '',
		},
		openDelay: {
			type: Number,
			default: 0,
		},
		apiParam: {
			type: Object,
			default: () => ({}),
		},
		scoresData: {
			type: Object,
		},
	},
	data() {
		return {
			shopScores: {},
			loading: false,
		};
	},
	methods: {
		async loadShopScores() {
			try {
				const res = await shopScores(this.apiParam);
				this.loading = false;
				this.shopScores = res;
			} finally {
				this.loading = false;
			}
		},
		handleShow() {
			this.loading = true;
			this.loadShopScores();
		},
		handleAfterLeave() {},
	},
};
</script>
<style lang="less">
.custom-popper-l {
	padding: 16px;
}
</style>
